import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const criteria = ['Jesteś trenerem piłki nożnej, szkoleniowcem lub instruktorem w klubie, szkole lub akademii', 'Masz dość ciężkiej pracy bez jasnego systemu który ją wspiera', 'Chcesz przestać wymyślać plan treningowy co tydzień samodzielnie', 'Chcesz żeby trening działał dobrze nawet w dniu gdy nie jesteś w 100% przygotowany', 'Chcesz żeby rodzice widzieli konkretne wyniki pracy z ich dziećmi', 'Chcesz rozwijać każdego zawodnika systematycznie i mierzalnie'];
export function WhoFor() {
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-283">
      <div className="max-w-6xl mx-auto" data-id="element-284">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-white mb-8 md:mb-12" data-id="element-285">
          Ten system jest dla Ciebie jeśli...
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-286">
          {criteria.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-5 md:p-6 shadow-lg flex gap-3 md:gap-4 h-full" data-id="element-287">
              <div className="flex-shrink-0" data-id="element-288">
                <div className="w-6 h-6 md:w-8 md:h-8 rounded-full bg-gold-accent flex items-center justify-center" data-id="element-289">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-navy-primary" data-id="element-290" />
                </div>
              </div>
              <p className="text-sm md:text-base text-gray-700 leading-relaxed" data-id="element-291">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}